import Vue from 'vue';

const success = (data, resolve) => {
  resolve();
};

const failed = (error, reject) => reject(error);

export default productIds => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/products/update/bulk-sync-to-woo', { product_ids: productIds })
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/bulkSyncToWoo.js